var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import Modal from "../../UI/Modal/Modal";
import ModalHeader from "../../UI/Modal/ModalHeader";
import TagService from "../../../Services/Tag.service";
import { CancelButton, SaveButton, } from "../../UI/StandardButtons/StandardButtons";
import useService from "../../Hooks/useService";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import { debouncePromise } from "../../../../util/debounce";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import useUniqueId from "../../Hooks/useUniqueId";
const EditTagModal = (_a) => {
    var { tags, studentPersonId, onTagsAssigned } = _a, modalProps = __rest(_a, ["tags", "studentPersonId", "onTagsAssigned"]);
    const { control, handleSubmit } = useForm({
        defaultValues: {
            tags,
        },
    });
    const [assignTagState, assignTags] = useService(TagService.assignTagsToPerson);
    const makeId = useUniqueId()[1];
    const submit = (state) => {
        assignTags(studentPersonId, state.tags.map((tag) => { var _a; return (_a = tag.id) === null || _a === void 0 ? void 0 : _a.toString(); })).then(() => {
            modalProps.onModalClosed();
            if (onTagsAssigned) {
                onTagsAssigned(state.tags);
            }
        });
    };
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: "Edit Tags", closeModal: modalProps.onModalClosed }), _jsxs("form", { onSubmit: handleSubmit(submit), children: [_jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("tags"), children: "Tags" }), _jsx(Controller, { as: _jsx(DeprecatedSelect.Async, { id: makeId("tags"), loadOptions: debouncePromise((query) => TagService.search(query).then((options) => ({
                                                options,
                                            }))), "aria-label": "Tags", multi: true, labelKey: "name", valueKey: "id" }), control: control, name: "tags" })] }), assignTagState.hasError && (_jsx(AlertError, { message: "There was an error assigning these tags", detail: assignTagState.errorMessage }))] }), _jsxs("div", { className: "modal-footer", children: [_jsx(SaveButton, { type: "submit", isLoading: assignTagState.isLoading }), _jsx(CancelButton, { onClick: () => modalProps.onModalClosed() })] })] })] })));
};
export default EditTagModal;
